export const CHOICES = [
	{ id: 0, value: "beef", name: "Onion", amount: 0.35 },
	{ id: 1, value: "unbeef", name: "Swiss Cheese", amount: 0.55 },
	{ id: 2, value: "chicken", name: "Pickles", amount: 0.85 },
];
